// @flow
import { Layout } from 'antd/lib/index';
import NoAccountsLogo from 'bil-front-commons/lib/ressources/images/background/no_accounts.png';
import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import connect from 'react-redux/es/connect/connect';
import { handleServerError, postAccountSelection } from '../../api/Payment';
import BILFooterPSD2 from '../../components/BILFooterPSD2/BILFooterPSD2';
import BILHoldersSelectionList from '../../components/BILHolders/BILHoldersSelectionList';
import BILLoader from '../../components/BILLoader/BILLoader';
import BILPageHeader from '../../components/BILPageHeader';
import LanguagePanel from '../../components/LanguagePanel/LanguagePanel';
import { checkUserDevice, scrollToTop } from '../../hooks/useWindowDimensions';
import { savePaymentSuccess } from '../../stores/PaymentSuccessParam/PaymentSuccessParamActions';
import BILHoldersUtil from '../../utils/BILHoldersUtil';
import { handleLanguageChange } from '../../utils/LanguageUtils';
import redirectTo from '../../utils/RedirectUtil';
import { savePaymentInfo } from '../../stores/PaymentInfoParam/PaymentInfoParamActions';
import { getPaymentInfo } from '../../api/Payment';

//// JS MAIN
const AccountSelection = (props) => {

   useEffect(() => {
      scrollToTop();
   }, []);

   useEffect(() => {
      BILHoldersUtil.reorganizeBorder()
   });

   const [isLoading, setLoading] = useState(false);
   const isRunningOnMobile = checkUserDevice();

   const { paymentInfo } = props;
   const confirmationButtonID = 'BILConfirmationButton'
   const radioInputID = 'payment'
   console.log(paymentInfo)

   if (!isLoading) {

      var data = BILHoldersUtil.MSCashDtoToBILHoldersListDto(paymentInfo.accounts)

      if (paymentInfo.accounts.length === 1) {
         handlePaymentAccountSelection(props, paymentInfo.accounts[0].iban, setLoading)
      } else {
         return (
            <Layout style={{ background: 'none' }}>
               <BILPageHeader
                  setLoading={setLoading}
                  {...props}
               />
               {isRunningOnMobile ? null :
                  <LanguagePanel
                     right={true}
                     onLanguageChange={(language) => handleLanguageSelection(props, language, setLoading)}
                     {...props}
                  />}
               {paymentInfo.accounts.length > 0 ?
                  <div className="BILHoldersList-selection-container" style={{ marginTop: "-54px" }}>
                     <div className="BILHoldersList-selection-container__title">
                        <FormattedMessage id="account-selection.title" />
                     </div>
                     <div className="BILHoldersList-selection__" >
                        {
                           data.ownershipTypeList.map((ownershipType, i) => {
                              return (
                                 <div key={i}>
                                    <div className="bil-role-title">
                                       <FormattedMessage id={"role." + BILHoldersUtil.toFrontRole(ownershipType)} />
                                    </div>
                                    {
                                       data.BILHoldersListDto.map((BILHoldersDto, i) => {
                                          if (BILHoldersDto.ownershipType === ownershipType) {
                                             return (
                                                <BILHoldersSelectionList
                                                   key={ownershipType + i}
                                                   BILHoldersDto={BILHoldersDto}
                                                   confirmationButtonID={confirmationButtonID}
                                                   radioInputID={radioInputID}
                                                />
                                             )
                                          } return null
                                       })
                                    }
                                 </div>
                              )
                           })
                        }
                     </div>
                     <BILFooterPSD2
                        onClickConfirm={() => {
                           var selectedIBAN = document.querySelector('input[name=' + radioInputID + ']:checked')
                           if (selectedIBAN !== null) {
                              handlePaymentAccountSelection(props, selectedIBAN.value, setLoading)
                           }
                        }}
                        onClickAbort={() => handlePaymentAbort(props, setLoading)}
                        continueId={confirmationButtonID}
                        continueDefaultEnabled={false}
                        onlyOneButton={false}
                        {...props}
                     />
                  </div>
                  :
                  <div className="BILHoldersList-selection-container" style={{ marginTop: "-54px" }}>
                     <div className="BILHoldersList-selection-container__title">
                        <FormattedMessage id="no-account-selection.title" />
                     </div>
                     <img src={NoAccountsLogo} className="no-accounts_logo" alt="No eligible accounts" />
                     <BILFooterPSD2
                        onClick={() => handlePaymentAbort(props, setLoading)}
                        onlyOneButton={true}
                        buttonType={'continue'}
                        {...props}
                     />
                  </div>}
            </Layout>
         )
      }
   } else {
      return (
         <div className="intl-spinner-container">
            <BILLoader style={{ fontSize: 55 }} />
         </div>
      );
   }
}

//// JS FUNCTIONS
function handleLanguageSelection(props, language, setLoading) {
   const { history, paymentInfo, savePaymentInfo } = props;

   setLoading(true);
   getPaymentInfo(paymentInfo.paymentRef, language.value)
   .then((response) => savePaymentInfo(response.data))
   .catch((error) => handleServerError(error, language, history))
   .finally(() => handleLanguageChange(props, language, setLoading))
}


function handlePaymentAccountSelection(props, selectedIBAN, setLoading) {
   const { language, history, paymentInfo } = props;

   setLoading(true);
   window.setTimeout(() => {
      postAccountSelection(paymentInfo.paymentRef, selectedIBAN)
         .then(() => history.push(`/${language}/${paymentInfo.paymentRef}`))
         .catch((error) => handleServerError(error, language, history))
   }, 600)
}

function handlePaymentAbort(props, setLoading) {
   const { language, history, savePaymentSuccess } = props;

   setLoading(true);
   savePaymentSuccess('payment.aborted.message')
   redirectTo(history, `/${language}/result?status=success`)
};

//// JS REDUX
const mapStateToProps = (state) => ({
   language: state.intl.locale,
   paymentInfo: state.paymentInfoParam.paymentInfo
});

const mapDispatchToProps = {
   savePaymentInfo,
   savePaymentSuccess
};

export default connect(mapStateToProps, mapDispatchToProps)(AccountSelection);
